import WithGASetup from './WithGASetup.js';

export default WithGASetup;
